import React from 'react';

import './index.scss';

// eslint-disable-next-line react/prop-types
export default function Tooltip({ children }) {
  return (
    <div className="typography-tooltip">{ children }</div>
  );
}
